@if (account(); as account) {
  <span class="accountSignature d-flex align-items-center">
    <span
      class="accountSignature_avatar"
      [matTooltip]="account | accountDisplayName"
      [matTooltipDisabled]="!displayTooltip()"
    >
      {{ account | accountDisplayName: true }}
    </span>

    @if (!onlyAvatar()) {
      <span class="accountSignature_displayName ms-1">
        {{ account | accountDisplayName }}
      </span>
    }
  </span>
}
